import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { DataConfirm } from './pdf-password.service';

@Component({
    selector: 'pdf-password',
    styleUrls: ['./pdf-password.component.scss'],
    template: `
    <mat-card>
      <h1 matDialogTitle class="mb-8">{{ data.title }}</h1>
      <div mat-dialog-content class="mb-16">
    
        @if (data?.message) {
          <div [innerHTML]="data?.message"></div>
          } <br/><br/>
    
          <mat-form-field class="example-form-field">
            <mat-label>Senha do arquivo</mat-label>
            <input matInput type="password" [(ngModel)]="value">
            @if (value) {
              <button matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
        <div mat-dialog-actions class="pb-4">
          <div class="dialog-actions-layout">
    
            <div class="action-item">
              <button
                mat-dialog-close
                color="accent"
                mat-raised-button
                type="button"
                (click)="dialogRef.close(false)"
                class="w-full"
                >
                Cancelar
              </button>
            </div>
    
            <div class="action-item">
              <button
                mat-flat-button
                type="submit"
                color="primary"
                [disabled]="!value.length"
                (click)="dialogRef.close(value)"
                class="w-full ml-none"
                >
                Enviar
              </button>
            </div>
    
          </div>
        </div>
      </mat-card>
    `,
    standalone: false
})
export class PdfPasswordComponent {
  value: string = '';
  constructor(
    public dialogRef: MatDialogRef<PdfPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataConfirm,
  ) {
  }
}
